<template>
  <pages-wrapper>
    <div class="contacts">
      <h1 class="contacts-title">
        {{ pageTitle }}
      </h1>

      <div
        class="contacts-card-content"
        v-html="PAGE_CONTENT"
      />

      <h4>Мы в соцсетях</h4>
      <social-networks class="contacts__social-networks" />
    </div>
  </pages-wrapper>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import pageMetaMixin from '@/mixins/page-meta-mixin';

/* Components */
import SocialNetworks from '@/components/common/social-networks/social-networks';
import PagesWrapper from '@/components/info-pages/pages-wrapper';

export default {
  name: 'contacts',

  metaInfo() {
    return this.getPageMeta({ pageTitle: this.pageTitle });
  },

  components: {
    SocialNetworks,
    PagesWrapper
  },

  mixins: [pageMetaMixin],

  data() {
    return {
      pageTitle: 'Контакты',
      content: null,
    }
  },

  computed: {
    ...mapGetters({
      PAGE_CONTENT: 'staticPages/page'
    })
  },

  methods: {
    ...mapActions({
      LOAD_STATIC_PAGE: 'staticPages/loadStaticPage'
    })
  },

  serverPrefetch() {
    return this.LOAD_STATIC_PAGE();
  }
};
</script>

<style lang="scss">
.contacts {
  &__social-networks {
    margin-top: 16px;
  }
}
</style>
